/* Publish by EComposer at 2026-11-03 11:25:29*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nhjv3m20gx"]=  window.__ectimmers["ecom-nhjv3m20gx"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nhjv3m20gx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nhjv3m20gx', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nhjv3m20gx', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}